import client from "./sharedoClient";

const getRoles = sharedoTypeSystemName => {
  const payload = {
    allowedAncestorTypePaths: [],
    excludedRoleSystemNames: [],
    includeAncestors: false,
    includeRoleSystemNames: [],
    sharedoTypeSystemName
  };

  return client.post("api/graph/queries/roleIndexer/config", payload);
}

export default {
  getRoles
}